export enum AuthType {
    Enterprise = "ENTERPRISE",
    Candidate = "CANDIDATE"
}

export enum Policies {
    Full = "FULLY",
    Hybrid = "HYBRID",
    Optional = "OPTIONAL",
    Mixed = "MIXED"
}

export enum TypeofWork {
    "FullTime",
    "PartTime",
    "Contract"
}

export enum AuthFlow {
    "employerLogin",
    "employerSignup",
    "candidateLogin",
    "candidateSignup"
}

export enum AutoAccountAction {
  Resume = 'resume',
  Pause = 'pause',
}

export enum PricingPlanType {
    Professional,
    Premium,
    Ultimate,
    Trial,
    Elite,
    ProfessionalQuarterly,
    UltimateQuarterly,
    EliteQuarterly
}
